import { useQuery } from "@apollo/client/react";
import FirstTimeTourBanner from "@components/FirstTimeUserTour/FirstTimeTourBanner";
import { useWidgetLayout } from "@src/context/widgetContext";
import { useEffect } from "react";

import { DashboardInbox } from "./dashboardInbox/DashboardInbox";
import { DashboardRecorder } from "./DashboardRecorder";
import { TestRecordings } from "./TestRecordings";
import currentUserQuery from "../../graphql/queries/CurrentUser";
import { useOnboarding } from "../../hooks";
import FullScreenLoading from "../common/loading/FullScreenLoading";
import PageTitle from "../layout/PageTitle";

function UserDashboard() {
  useOnboarding();

  const { loading, data } = useQuery(currentUserQuery, {
    fetchPolicy: "no-cache",
  });

  const { isAppHeaderVisible } = useWidgetLayout();

  useEffect(() => {
    // "document.documentElement.scrollTo" is the magic for React Router Dom v6
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional if you want to skip the scrolling animation
    });
  }, []);

  if (loading && !data?.user) {
    return null;
  }

  return (
    <div className="flex flex-col flex-1">
      <FullScreenLoading loadingTrigger={loading} />

      <TestRecordings data={data} />

      <div className="relative">
        <PageTitle title="Dashboard" />
      </div>

      <FirstTimeTourBanner />

      <div className="flex flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-10 my-6">
        <div
          className={`flex-1 md:mt-0 ${
            isAppHeaderVisible && "mt-20"
          } self-stretch justify-self-center flex items-center justify-center text-secondary`}
        >
          <DashboardRecorder />
        </div>

        <div
          id="dashboardInbox"
          className="md:w-[28rem] shrink-0 flex flex-col"
          data-testid="dashboard-inbox"
        >
          <DashboardInbox />
        </div>
      </div>
    </div>
  );
}

export default UserDashboard;
